import { Colors } from "colors";
import VText from "components/VText";
import React, { useEffect } from "react";
import { View, Image, TouchableOpacity, StyleSheet } from "react-native";
import { fp } from "utils/normalizeV2";

const SelectSizeView = ({
  outfitData,
  _sizeGuideRef,
  setCartData,
  cartData,
  setIsAddToCartEnabled,
}) => {
  useEffect(() => {
    setCartData([]);
  }, [setCartData]);

  useEffect(() => {
    if (cartData?.length === outfitData?.length) {
      setIsAddToCartEnabled(true);
    } else {
      setIsAddToCartEnabled(false);
    }
  }, [cartData, outfitData?.length, setIsAddToCartEnabled]);

  const renderSizeOptions = (product, categoryName, productSizes) => {
    const selectedSize = cartData?.find(
      (item) => item?.productId === product.id
    )?.size;

    return (
      <View style={styles.categoryContainer}>
        <View style={styles.categoryHeader}>
          <VText style={styles.categoryName}>{categoryName}</VText>
          {product?.sizeGuide?.length > 0 && (
            <TouchableOpacity
              onPress={() => {
                _sizeGuideRef?.current?.show(
                  product,
                  cartData.find((item) => item?.productId === product.id)?.size
                );
              }}
            >
              <VText style={styles.viewSizeGuide}>View Size Guide</VText>
            </TouchableOpacity>
          )}
        </View>
        <View style={styles.sizeOptionsContainer}>
          {productSizes.map((size, index) => (
            <TouchableOpacity
              onPress={() => {
                const newCartData = cartData.filter(
                  (item) => item.productId !== product.id
                );
                setCartData([
                  ...newCartData,
                  { productId: product?.id, qty: 1, size: size },
                ]);
              }}
              key={index}
              style={[
                styles.sizeButton,
                selectedSize === size && styles.selectedSizeButton,
              ]}
            >
              <VText style={styles.sizeButtonText}>{size}</VText>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    );
  };

  const renderProductSection = (product) => {
    const { categoryName = "", productSizes = [] } = product;
    return (
      <View style={styles.productSection}>
        <Image
          source={{ uri: product?.imageUrls[0] }}
          style={styles.productImage}
          resizeMode="cover"
        />
        {renderSizeOptions(product, categoryName, productSizes)}
      </View>
    );
  };

  return (
    <View style={styles.container}>
      {outfitData &&
        outfitData?.map((product, index) => (
          <View key={index}>{renderProductSection(product)}</View>
        ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
  },
  productSection: {
    flexDirection: "row",
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
  },
  productImage: {
    width: 80,
    height: 80,
    marginRight: 16,
  },
  categoryContainer: {
    flex: 1,
  },
  categoryHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  categoryName: {
    fontSize: fp(16),
    fontWeight: "400",
    color: "#000",
  },
  viewSizeGuide: {
    fontSize: fp(12),
    fontWeight: "300",
    color: Colors.black60,
    textDecorationLine: "underline",
  },
  sizeOptionsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  sizeButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: "#CCCCCC",
    borderRadius: 4,
    marginBottom: 8,
  },
  selectedSizeButton: {
    borderColor: Colors.black,
  },
  sizeButtonText: {
    fontSize: fp(14),
    fontWeight: "300",
    color: "#000",
  },
});

export default React.memo(SelectSizeView);
